import IVenueSettings, { ITableRange } from "../interfaces/IVenueSettings";


interface IKeyValue {
    [key: string]: any;
}

function turnKeysIntoInts<T extends IKeyValue>(keys: string[], object: T) {
    const returnObj: IKeyValue = {};
    for (const key of keys) {
        if (typeof object[key] === "string") {
            returnObj[key] = parseInt(object[key]) || 0;
        }
    }
    return returnObj;
}

function turnKeysIntoFloats<T extends IKeyValue>(keys: string[], object: T) {
    const returnObj: IKeyValue = {};
    for (const key of keys) {
        if (typeof object[key] === "string") {
            returnObj[key] = parseFloat(object[key]) || 0;
        }
    }
    return returnObj;
}

const tableLayoutKeys = ["table_range_lower_bound", "table_range_upper_bound"];

export function turnTableLayoutObjectIntoArray(tableLayoutObject: { [key: string]: ITableRange; }) {
    if (tableLayoutObject === undefined) {
        return undefined;
    }
    const objKey = Object.keys(tableLayoutObject);
    const newArrayOfLayouts = [];
    for (const key of objKey) {
        const object = tableLayoutObject[key];
        /**If these are undefined we don't want the object  */
        if (object.table_range_lower_bound === undefined || object.table_range_lower_bound === undefined) {
            return;
        }
        const values = {
            ...object,
            ...turnKeysIntoInts(tableLayoutKeys, object)
        };
        newArrayOfLayouts.push(values);
    }
    return newArrayOfLayouts;
};

const prepKeys = ["drinks_prep_time", "food_prep_time", "delivery_min_lead_time", "delivery_max_lead_time", "service_charge_pence_amount", "service_charge_percentage_amount"];
export function transformPrepation(data: IVenueSettings) {
    const object = {
        ...data,
        ...turnKeysIntoInts(prepKeys, data)
    };
    return object;
}
export function transformPrepationFloat(data: IVenueSettings) {
    const object = {
        ...data,
        ...turnKeysIntoFloats(prepKeys, data)
    };
    return object;
}
// DEPRECATED??
const orderKeys = ["delivery_charge", "pickup_max_lead_time", "min_delivery_price", "pickup_min_lead_time", "delivery_max_lead_time"];
export function transformOrderTypes(data: IVenueSettings) {
    const object = {
        ...data,
        ...turnKeysIntoInts(orderKeys, data)
    };
    return object;
}

export function transformURLs(data: IVenueSettings) {
    return {
        ...data,
        custom_links: data.custom_links ? Object.values(data.custom_links) : undefined
    }
}

// DEPRECATED??
const deliverKey = ["delivery_min_lead_time", "delivery_max_lead_time", "min_delivery_price", "delivery_radius"];
export function transformDelivery(data: IVenueSettings) {
    const object = {
        ...data,
        ...turnKeysIntoInts(deliverKey, data),
    };
    return object;
}
const venueFees = ["delivery_charge", "min_delivery_price", "delivery_radius", "min_table_price", "table_range_upper_bound", "table_range_lower_bound"];
export function transformVenueFees(data: IVenueSettings) {
    const object = {
        ...data,
        ...turnKeysIntoInts(venueFees, data),
        table_layout: turnTableLayoutObjectIntoArray(data.table_layout as {})
    };
    return object;
}